import { DateRange } from '../../redux/dateRangeSlice';
import { post } from '..';

const GetHomeScreenMetrics = (range: DateRange) => {
  const endpoint: string = 'metrics/query';
  const body = [
    {
      aggregationFunction: 'avg',
      from: range.start,
      interval: '1h',
      metric: 'zone_air_temperature_sensor',
      to: range.end,
      queryType: 'OVER_TIME',
    },
    {
      metric: 'zone_occupancy_count',
      queryType: 'CURRENT',
      aggregationFunction: 'max',
    },
    {
      metric: 'zone_hours_booked',
      queryType: 'CURRENT',
    },
    {
      aggregationFunction: 'sum',
      from: range.start,
      metric: 'processed_energy_accumulator',
      to: range.end,
      queryType: 'AGGREGATION',
    },
    {
      aggregationFunction: 'sum',
      from: range.start,
      metric: 'processed_water_volume_accumulator',
      to: range.end,
      queryType: 'AGGREGATION',
    },
  ];
  return post(endpoint, body);
};

export default GetHomeScreenMetrics;
